<template>
  <div class="no-data">
    <div class="content">
      <img src="./../assets/img/noData.png" />
      <p class="words">{{ $t("noData") }}</p>
    </div>
  </div>
</template>
<script>
export default {
  name: "noData",
  props: {},
};
</script>
<style scoped>
.no-data {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.content {
  max-width: 50%;
  margin: 6rem 0;
}
.words {
  margin-top: 1.6rem;
  color: #838383;
  text-align: center;
  font-size: 1.4rem;
  font-family: PingFang SC;
}
</style>



// WEBPACK FOOTER //
// src/base/noData.vue